import { useTranslation } from 'react-i18next';

import { breakpoints } from '@pulse-web-ui/theme';

import type { Profile } from '@entities/agent-contract';

import { useIsDesktop } from '@shared/hooks';
import { Section } from '@shared/index';

import { useGetProfileSectionHeaderStyles } from '../../hooks';
import type { AgentProfileSectionProps } from '../../model';
import { getBankDetails, getBankDetailsTranslations } from '../../utils';

interface BankDetailsSectionProps extends AgentProfileSectionProps {
  bankDetails: Profile['bankDetails'];
  bankDetailsToCompare?: Profile['bankDetails'];
}

export const BankDetailsSection = ({
  bankDetails,
  bankDetailsToCompare,
  isRenderTitle,
  isSubmitSection,
  buttonProps,
}: BankDetailsSectionProps) => {
  const { t } = useTranslation();
  const isDesktop = useIsDesktop(breakpoints.DESKTOP);
  const dataLabels = getBankDetailsTranslations(t);
  const data = getBankDetails(bankDetails);
  const dataToCompare =
    bankDetailsToCompare && getBankDetails(bankDetailsToCompare);

  const userHasBankDetails = Object.values(data).some((item) => !!item);

  const header = useGetProfileSectionHeaderStyles({
    title: isRenderTitle ? t('AGENT_PROFILE:headers.bankDetails') : undefined,
    isDesktop,
    isSubmitSection,
    buttonProps,
  });

  return (
    userHasBankDetails && (
      <Section
        data={data}
        dataToCompare={dataToCompare}
        dataLabels={dataLabels}
        header={header}
      />
    )
  );
};
